export default{
    // general
    "clinics.clinicDetails.redirecting" : "Redirecting...",
    "clinics.clinicDetails.list"        : "Clinics List",
    "clinics.clinicDetails.404"         : "This clinic page has been moved, deleted or does not exist.",
}